import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ModulePicker } from "@/components/plans/ModulePicker";
import { brl } from "@/lib/api";
import { customTotals, readChoice, saveChoice } from "@/lib/modules";

export function CustomPlanDialog({ plan, catalog, onClose }) {
  const navigate = useNavigate();
  const [mods, setMods] = useState(() => readChoice().filter((m) => plan.modules.includes(m)));
  const { monthly, yearly } = customTotals(plan, mods);
  const start = () => {
    saveChoice(mods);
    navigate(`/cadastro?modulos=${mods.join(",")}`);
  };
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto" data-testid="landing-custom-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">{plan.name}</DialogTitle>
          <DialogDescription>Marque os módulos que você quer usar. O valor do plano é a soma dos módulos escolhidos. No teste grátis tudo fica liberado.</DialogDescription>
        </DialogHeader>
        <ModulePicker plan={plan} catalog={catalog} value={mods} onChange={setMods} testPrefix="landing-custom" />
        <div className="sticky -bottom-6 -mx-6 -mb-6 flex flex-wrap items-center gap-3 border-t bg-card px-6 py-4">
          <div className="flex-1">
            <p className="text-xs text-muted-foreground">{mods.length} módulo(s) · total por mês</p>
            <p className="font-display text-2xl font-bold" data-testid="landing-custom-total">{brl(monthly)}</p>
            {yearly > 0 && <p className="text-xs text-muted-foreground" data-testid="landing-custom-yearly">ou {brl(yearly)}/ano (-{plan.yearly_discount ?? 15}%)</p>}
          </div>
          <Button size="lg" disabled={!mods.length} onClick={start} data-testid="landing-custom-start-btn">Começar teste grátis<ArrowRight className="ml-1 h-4 w-4" /></Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
